import * as React from "react";
import {useState} from "react";
import {Button} from "@mui/material";
import {LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {useGetTemplatesQuery} from "../../../services/templates";
import {useGetEmailListsQuery} from "../../../services/emailListApi";
import {useCreateTaskMutation} from "../../../services/tasks";
import {toast} from "react-toastify";
import TaskDialog, {TaskDialogValues} from "./TaskDialog";
import {CreateTaskDto} from "../../../types/task";


export default function ScheduleEmailFormDialog() {
  const [createTask, { isLoading }] = useCreateTaskMutation();
  const [isTaskDialogOpend, setIsTaskDialogOpend] = useState(false);

  const { data: templates = [] } = useGetTemplatesQuery();
  const { data: destinationEmailList = [] } = useGetEmailListsQuery();
  const destinationOptions = destinationEmailList.map((x) => ({
    id: x.id,
    label: x.title
  }));
  const templateOptions = templates.map((t) => ({
    id: t.id,
    label: t.name
  }));

  const initialValues: Partial<TaskDialogValues> = {
    subject: "",
    hiddenPreview: "",
    scheduleDate: dayjs(),
    destinationListId: "",
    templateId: ""
  };

  const handleSubmit = async (v: TaskDialogValues) => {
    const payload: CreateTaskDto = {
      title: v.subject,
      hiddenText: v.hiddenPreview,
      planedDate: v.scheduleDate!.toDate().toISOString(),
      targetListId: v.destinationListId,
      templateId: v.templateId
    };

    try {
      await createTask(payload).unwrap();
      setIsTaskDialogOpend(false);
    } catch (e) {
      toast.error("Failed to schedule email task, please try again.");
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Button variant="contained" onClick={() => setIsTaskDialogOpend(true)}>
        New Email Task
      </Button>

      <TaskDialog
        open={isTaskDialogOpend}
        mode="create"
        initialValues={initialValues}
        onClose={() => setIsTaskDialogOpend(false)}
        onSubmit={handleSubmit}
        destinationOptions={destinationOptions}
        templateOptions={templateOptions}
        submitting={isLoading}
      />
    </LocalizationProvider>
  );
}
